import React from "react";
import styled from "styled-components";
import { LabelEl, SelectWrapper, SelectEl } from "src/react/forms/styles";
import Tracking from "src/react/components/tracking";

export function Select(props) {
  const {
    field: { name, value, onChange, onBlur },
    form: { errors, touched },
    label = "",
    type = "text",
    children,
    inline,
    wrapperCss,
    tracking,
    trackingOptions,
    ...restProps
  } = props;
  const hasValue = value !== "";
  const isValid = touched[name] != null && hasValue && errors[name] == null;
  const isInvalid =
    touched[name] != null && (errors[name] != null || !hasValue);

  return (
    <Wrapper inline={inline} wrapperCss={wrapperCss}>
      {label && (
        <LabelEl htmlFor={name} visible={hasValue}>
          {label}
        </LabelEl>
      )}
      <SelectWrapper>
        <Tracking tracking={tracking} trackingOptions={trackingOptions}>
          <SelectEl
            id={name}
            disabled={props.disabled}
            {...{ isValid, isInvalid, name, value, onChange, onBlur, type }}
            {...restProps}
          >
            {props.placeholder && (
              <option value="" disabled>
                {props.placeholder}
              </option>
            )}
            {children}
          </SelectEl>
        </Tracking>
      </SelectWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  ${({ inline }) => inline && `display: inline-block; margin-right: 20px;`};
  ${({ wrapperCss }) => wrapperCss};
`;
